import React, { useState, useEffect } from 'react'
import { Box, CircularProgress } from '@material-ui/core'

/**
 * Higher-Order Component để thêm chức năng loading spinner cho các component
 * @param {React.Component} WrappedComponent - Component cần được bọc
 * @param {Object} options - Các tùy chọn cấu hình
 * @param {number} options.loadingTime - Thời gian hiển thị loading (ms)
 * @param {string} options.backgroundColor - Màu nền của container loading
 * @param {number} options.minHeight - Chiều cao tối thiểu của container loading
 * @returns {React.Component} Component mới có chức năng loading
 */
export const withLoading = (WrappedComponent, options = {}) => {
	const { loadingTime = 1000, backgroundColor = '#ffffff', minHeight = 80 } = options

	return (props) => {
		const [isLoading, setIsLoading] = useState(true)

		useEffect(() => {
			const timer = setTimeout(() => {
				setIsLoading(false)
			}, loadingTime)

			return () => clearTimeout(timer)
		}, [])

		return (
			<div style={{ position: 'relative', width: '100%' }}>
				<div style={{ opacity: isLoading ? 0 : 1, transition: 'opacity 0.3s ease-in-out' }}>
					<WrappedComponent {...props} />
				</div>

				{isLoading && (
					<div
						style={{
							backgroundColor,
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							minHeight: `${minHeight}px`,
							zIndex: 10,
						}}
					>
						<CircularProgress size={40} color="primary" />
					</div>
				)}
			</div>
		)
	}
}
